
import ReviewCard from '../components/review/ReviewCard';
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../api/api';
import LoadingLogo from '../components/Loading';
import Pagination from '../components/Pagination';



const Reviews = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  // Search & Filters
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('all'); // 'all', 'walk', 'delivery'

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [meta, setMeta] = useState({
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    from: 1,
    to: 1
  });

  // On mount + whenever filter/currentPage changes, fetch data
  useEffect(() => {
    fetchData();
  }, [filter, currentPage]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api.get('/feedbacks', {
        params: {
          search: searchTerm,
          filter: filter,
          page: currentPage,
        },
      });

      setFeedbacks(response.data);
      setMeta(response.meta);
    } catch (error) {
      toast.error('Failed to fetch feedback.');
    } finally {
      setLoading(false);
    }
  };

  // Trigger fetchData() if user presses Enter in the search box
  const handleKeyDownSearch = (event) => {
    if (event.key === 'Enter') {
      setCurrentPage(1);
      fetchData();
    }
  };

  // Pagination handlers
  const handleNextPage = () => {
    if (meta.current_page < meta.last_page) {
      setCurrentPage(meta.current_page + 1);
    }
  };

  const handlePrevPage = () => {
    if (meta.current_page > 1) {
      setCurrentPage(meta.current_page - 1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= meta.last_page; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          className={`px-3 py-1 rounded-lg border border-tblue ${i === meta.current_page ? 'bg-tblue text-white' : 'bg-white text-gray-700'
            } hover:bg-tblue hover:text-white mx-1`}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  if (loading) {
    return <LoadingLogo />;
  }

  return (
    <div className="mx-auto px-4 py-2">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-tblue text-3xl font-bold">Customer Reviews</h1>
      </div>

      {/* Search and Filter */}
      <div className="flex space-x-4 mb-6">
        {/* Search Input */}
        <div className="flex items-center border border-gray-300 rounded-lg p-2 shadow-md transition-all duration-300 hover:shadow-lg focus-within:shadow-2xl focus-within:bg-bodyMain">
          <FontAwesomeIcon
            icon={faSearch}
            className="text-gray-400 mr-2 transition-transform duration-300 hover:scale-110"
          />
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDownSearch}
            className="outline-none focus:ring-0 bg-transparent w-full text-gray-700 placeholder-gray-400 focus:placeholder-gray-500 focus:text-black"
          />
        </div>

        {/* Filter by Service Type */}
        <select
          value={filter}
          onChange={(e) => {
            setFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="border rounded-lg p-2 shadow-sm"
        >
          <option value="all">All Feedback</option>
          <option value="walk">Walk Feedback</option>
          <option value="delivery">Delivery Feedback</option>
        </select>


      </div>

      {/* Feedback Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {feedbacks.map((feedback) => (
          <ReviewCard key={feedback.id} review={feedback} />
        ))}
      </div>

      {/* Smart Pagination */}
      <Pagination
        meta={meta}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
};


export default Reviews;


